import React from "react";

import css from "./HorizontalLine.module.scss";

type HorizontalLineProps = React.PropsWithChildren & {
  beforeSlot?: React.ReactNode;
  afterSlot?: React.ReactNode;
};

export function HorizontalLine({ beforeSlot, afterSlot }: HorizontalLineProps) {
  return (
    <div className={css.Container}>
      {beforeSlot}
      <div className={css.HorizontalLine} />
      {afterSlot}
    </div>
  );
};

export default HorizontalLine;
